import { UtilitarioService } from '../services/utilitario.service';
export class SigiloAutorizacao{
    Id: number;
    SigiloId: number;
    UsuarioPermitidoId: number;
    DataPermitida: string;
    UsuarioAutorizouId: number;
    DataLiberacao: string;

    AnexoId: number;
    MovimentacaoId: number;

    constructor(){
        this.UsuarioPermitidoId = 0;
        this.DataPermitida = UtilitarioService.retornaDataAtualMaisDiasISO(0);
    }
}